export default function Card({ title, subtitle, actions, children, className = "", padded = true, as: Tag = "section", titleAs: Heading = "h2" }) {
  return (
    <Tag className={`card ${padded ? "" : "card-flush"} ${title || actions ? "has-header" : ""} ${className}`.replace(/\s+/g, " ").trim()}>
      {(title || actions) && (
        <header className="card-header">
          <div>
            {title && <Heading className="card-title">{title}</Heading>}
            {subtitle && <p className="card-subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="card-actions">{actions}</div>}
        </header>
      )}
      <div className="card-body">{children}</div>
    </Tag>
  );
}
